import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/Footer';

const FinancingOptionsPage = () => {
  const [searchParams] = useSearchParams();
  const iframeRef = useRef(null);

  useEffect(() => {
    const amount = searchParams?.get('amount');
    
    if (amount && iframeRef?.current) {
      // Wait for iframe to load before sending message
      const handleIframeLoad = () => {
        try {
          iframeRef?.current?.contentWindow?.postMessage(
            { type: 'SET_AMOUNT', amount: parseInt(amount) },
            'https://www.enhancify.com'
          );
        } catch (error) {
          console.log('Could not send amount to iframe:', error);
        }
      };

      if (iframeRef?.current) {
        iframeRef?.current?.addEventListener('load', handleIframeLoad);
        return () => {
          iframeRef?.current?.removeEventListener('load', handleIframeLoad);
        };
      }
    }
  }, [searchParams]);

  return (
    <>
      
      <Header />
      
      {/* Spacer to push content below header */}
      <div 
        id="financingTopSpacer" 
        className="h-[170px] lg:h-[140px]"
        style={{ background: 'transparent' }}
      />
      
      {/* Enhancify iframe embed */}
      <div 
        id="enhancify-financing-wrapper"
        style={{
          width: '100%',
          padding: 0,
          margin: 0,
          overflow: 'hidden',
          position: 'relative'
        }}
      >
        <iframe
          ref={iframeRef}
          src="https://www.enhancify.com/openbooq"
          title="OpenbooQ Financing"
          loading="lazy"
          style={{
            width: '100%',
            height: '1200px',
            border: 'none',
            display: 'block',
            position: 'relative'
          }}
          className="md:h-[1200px] h-[1400px]"
        />
      </div>
      
      <Footer />
    </>
  );
};

export default FinancingOptionsPage;